module.exports = __webpack_public_path__ + "static/workflow-mobile-e1941e4d072172ed155557f4e78e26d4.png";